/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bank_Account_CountryInputs */

const en_bank_account_country = /** @type {(inputs: Bank_Account_CountryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bank account country`)
};

const es_bank_account_country = /** @type {(inputs: Bank_Account_CountryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`País de la cuenta bancaria`)
};

const fr_bank_account_country = /** @type {(inputs: Bank_Account_CountryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pays du compte bancaire`)
};

const de_bank_account_country = /** @type {(inputs: Bank_Account_CountryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Land des Bankkontos`)
};

const ja_bank_account_country = /** @type {(inputs: Bank_Account_CountryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`銀行口座の所在国`)
};

const zh_bank_account_country = /** @type {(inputs: Bank_Account_CountryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`银行账户所在国家`)
};

const ar_bank_account_country = /** @type {(inputs: Bank_Account_CountryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بلد الحساب المصرفي`)
};

const id_bank_account_country = /** @type {(inputs: Bank_Account_CountryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Negara rekening bank`)
};

const it_bank_account_country = /** @type {(inputs: Bank_Account_CountryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paese del conto bancario`)
};

const ru_bank_account_country = /** @type {(inputs: Bank_Account_CountryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Страна банковского счета`)
};

const pt_bank_account_country = /** @type {(inputs: Bank_Account_CountryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`País da conta bancária`)
};

const ko_bank_account_country = /** @type {(inputs: Bank_Account_CountryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`은행 계좌 개설 국가`)
};

/**
* | output |
* | --- |
* | "Bank account country" |
*
* @param {Bank_Account_CountryInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const bank_account_country = /** @type {((inputs?: Bank_Account_CountryInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bank_Account_CountryInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_bank_account_country(inputs)
	if (locale === "es") return es_bank_account_country(inputs)
	if (locale === "fr") return fr_bank_account_country(inputs)
	if (locale === "de") return de_bank_account_country(inputs)
	if (locale === "ja") return ja_bank_account_country(inputs)
	if (locale === "zh") return zh_bank_account_country(inputs)
	if (locale === "ar") return ar_bank_account_country(inputs)
	if (locale === "id") return id_bank_account_country(inputs)
	if (locale === "it") return it_bank_account_country(inputs)
	if (locale === "ru") return ru_bank_account_country(inputs)
	if (locale === "pt") return pt_bank_account_country(inputs)
	return ko_bank_account_country(inputs)
});